<template>
    <div>
        <template v-if="isStatic">
            <div class="form-control form-control--static" :class="className">
                {{ item.title }}
            </div>
        </template>
        <template v-else>
            <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
                 <template v-if="hasPlaceholder">
                    <option value="">{{ placeholder }}</option>
                </template>
                <template v-for="item in items">
                    <option :value="item.id" v-bind:key="item.title" :selected="isSelectedItem(item.id)">{{ $t(item.lexiconTitle) }}</option>
                </template>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-element-usertype'
            },
            name : {
                type : String,
                name : 'usertype'
            },
            value : {
                type : [String, Number],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            isStatic : {
                type : Boolean,
                default : false
            }
        },
        data() {
            return {
                item    : {
                    title : '',
                    id: '',
                    lexiconTitle: ''
                },
                items   : this.getItems()
            };
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        methods : {
            getItems : function () {
                const usertype = [];
                const userTypeObject = this.$helpers.usertypes;

                Object.keys(userTypeObject).forEach((function (key) {

                    if (key != 'client' && key != 'admin') {
                        usertype.push({
                            title: key,
                            id: userTypeObject[key],
                            lexiconTitle: 'account.' + key
                        });
                    }
                   
                }).bind(this));

                return usertype;
            },
            onSelectItem : function (id) {
                this.$emit('input', id);
                 this.$emit('change', this.getItemById(id));
            },
            onChangeItem : function (event) {
                this.onSelectItem(event.currentTarget.value);
            },
            isSelectedItem : function (id) {
                return this.value === id;
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (item.id === id) {
                        output = item;
                    }
                }).bind(this));

                return output;
            }
        }
    }
</script>